/* eslint-disable react/no-unknown-property */
import { Avatar } from '@doveit/bricks';
import React from 'react';
import * as styles from './AgentLeaderboardItem.style';
import useIsDevice from '../../../hooks/use-is-device/useIsDevice';
import { AgentLeaderboardItemSize } from './types';
import { RankType } from '../../../providers/api/dtos';
import { getConfigByRank } from '../../utils/getConfigByRank';
import AgentRankPosition from '../agent-rank-position/AgentRankPosition';

export interface AgentLeaderboardItemProps {
  rank: number;
  rankingType?: RankType;
  name: string;
  sales: number;
  picture?: string;
  details?: string;
  highlighted?: boolean;
  size?: AgentLeaderboardItemSize;
}

export const AgentLeaderboardItem: React.FC<AgentLeaderboardItemProps> = ({
  rank,
  rankingType = 'AGENT',
  name,
  picture,
  sales,
  details,
  highlighted,
  size = 'M',
}) => {
  const isMobile = useIsDevice('mobile');
  const config = React.useMemo(
    () => getConfigByRank(rank, rankingType),
    [rank, rankingType],
  );

  return (
    <div
      css={styles.basic}
      $color={config.color}
      $highlighted={highlighted}
    >
      {rankingType === 'ROOKIE' && (
        <div
          css={styles.rookieLabel}
          $color={config.color}
        >
          <div>
            Rookie
          </div>
        </div>
      )}
      <div
        css={styles.wrapper}
        $size={size}
        $isMobile={isMobile}
      >
        <div css={styles.primary}>
          <div
            css={styles.rankBox}
            $size={size}
          >
            <AgentRankPosition
              rank={rank}
              rankingType={rankingType}
              size={size}
            />
          </div>
          <div css={styles.userBox}>
            <Avatar
              size={(isMobile || size === 'S') ? 'S' : 'M'}
              color={config.color}
              src={picture}
            />
            <div>
              <div css={styles.name}>
                {name}
              </div>
              {details && (
                <div css={styles.details}>
                  {details}
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          css={styles.salesBox}
          $color={config.color}
        >
          <div css={styles.salesCount}>
            {sales}
          </div>
          <div css={styles.salesLabel}>
            Vendite
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentLeaderboardItem;
